import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "py-10" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h1 class=\"anchor fw-bolder mb-5\" id=\"sizes\"><a href=\"#sizes\"></a> Sizes </h1><div class=\"py-5\"> Assign responsive-friendly size to a symbol element with shorthand classes. The classes are named using the format <code>.symbol-{size}</code> for <code>xs</code> and <code>.symbol-{breakpoint}-{size}</code> for <code>sm</code>, <code>md</code>, <code>lg</code>, <code>xl</code>, and <code>xxl</code>. </div>", 2)
const _hoisted_4 = { class: "py-5" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("code", null, "size", -1)
const _hoisted_6 = { class: "pt-3" }
const _hoisted_7 = { class: "py-5" }
const _hoisted_8 = { class: "rounded border p-10 pb-0 d-flex flex-wrap align-items-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "symbol-label fs-2 fw-bold text-success" }, "A", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "py-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_4, [
      _createTextVNode(" Where "),
      _hoisted_5,
      _createTextVNode(" is one of: "),
      _createElementVNode("ul", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.symbolSizes, (item, i) => {
          return (_openBlock(), _createElementBlock("li", {
            key: i,
            class: "py-2"
          }, [
            _createElementVNode("code", null, _toDisplayString(item), 1),
            _createTextVNode(" - for classes that set height and width to " + _toDisplayString(item), 1)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sizes, (item, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i,
            class: _normalizeClass([`symbol-${item}`, "symbol me-10 mb-10"])
          }, _hoisted_10, 2))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(`
        <div class="symbol symbol-30px">
          <div class="symbol-label fs-2 fw-bold text-success">A</div>
        </div>
        <div class="symbol symbol-50px">
          <div class="symbol-label fs-2 fw-bold text-success">A</div>
        </div>
        <div class="symbol symbol-75px">
          <div class="symbol-label fs-2 fw-bold text-success">A</div>
        </div>
        <div class="symbol symbol-100px">
          <div class="symbol-label fs-2 fw-bold text-success">A</div>
        </div>
        <div class="symbol symbol-125px">
          <div class="symbol-label fs-2 fw-bold text-success">A</div>
        </div>
        <div class="symbol symbol-150px">
          <div class="symbol-label fs-2 fw-bold text-success">A</div>
        </div>
        `))
        ]),
        _: 1
      })
    ])
  ]))
}